<img src="assets/images/atom_loading_spinner.gif" class="loader">
<div class="loader-text" *ngIf="text">{{ text }}</div>
